import styled from '@emotion/styled';
import { Container, Typography } from '@mui/material';

export const ProviderContainer = styled.div`
  background: ${({ theme }) => theme.palette.background.default};
  height: 100%;
`;

export const Title = styled.h1`
  width: 100%;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.palette.primary.contrastText};

  @media screen and (min-width: 600px) {
    font-weight: 800;
    font-size: 60px;
    line-height: 70px;
  }
`;

export const Subtitle = styled.h2`
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.palette.primary.contrastText};

  @media screen and (min-width: 600px) {
    font-weight: 700;
    font-size: 34px;
    line-height: 40px;
  }
`;

export const BodyContainer = styled.div`
  position: relative;
  margin-top: -40px;
  z-index: 6;
`;

export const MobileFilterContainer = styled(Container)`
  background-color: ${({ theme }) => theme.palette.primary.dark};
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 12px 0px;
  margin-bottom: 40px;
  &:hover {
    cursor: pointer;
  }

  @media screen and (min-width: 900px) {
    display: none;
  }
`;

export const FilterText = styled(Typography)`
  margin-left: 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;

export const FilterContainer = styled(Container)`
  padding: 0px !important;
  display: none;

  @media screen and (min-width: 900px) {
    display: flex;
    flex-direction: row;
  }
`;

export const ChipContainer = styled(Container)`
  padding: 0px !important;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-grow: 0;
  flex-wrap: wrap;
  min-height: 48px;
`;

export const BodyText = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.palette.text.primary};
`;
